import { LOGO_URL, LOGO_INVERSE } from "@/data/site";

/**
 * BurlyLogo, renders the official Burly logo image.
 *
 *  surface: "light" , default black-bg logo with mix-blend-mode: multiply
 *                      so the black PNG background disappears against a light
 *                      surface (used in the top navbar).
 *  surface: "dark"  , inverse logo asset (white BURLY on navy background) so
 *                      the wordmark remains clearly visible on the navy footer.
 */
export const BurlyLogo = ({ size = "h-12 w-12", surface = "light", testId }) => {
  if (surface === "dark") {
    return (
      <div
        className={`relative inline-block ${size}`}
        data-testid={testId}
        aria-label="Burly, brand logo"
      >
        <img
          src={LOGO_INVERSE}
          alt="Burly"
          className="h-full w-full object-contain"
        />
      </div>
    );
  }
  return (
    <div
      className={`relative inline-block ${size}`}
      data-testid={testId}
      aria-label="Burly, brand logo"
    >
      <img
        src={LOGO_URL}
        alt="Burly"
        className="h-full w-full object-contain"
      />
    </div>
  );
};
